/**
 * @author Fernando Ruano
 * @file constants.js
 * @description Patient Appointments Constants
 */

// Generic actions
export const GET_ALL_PATIENT_APPOINTMENTS =
  'Patient/GET_ALL_PATIENT_APPOINTMENTS';

export const CREATE_PATIENT_APPOINTMENTS =
  'Patient/CREATE_PATIENT_APPOINTMENTS';

export const GET_APPOINTMENT_AVAILABILITIES =
  'Patient/GET_APPOINTMENT_AVAILABILITIES';

export const CANCEL_PATIENT_APPOINTMENTS =
  'Patient/CANCEL_PATIENT_APPOINTMENTS';

export const RESCHEDULE_PATIENT_APPOINTMENTS =
  'Patient/RESCHEDULE_PATIENT_APPOINTMENTS';

export const GET_AGENDA_MATE_PATIENT = 'Patient/GET_AGENDA_MATE_PATIENT';
